import React, { useEffect, useState } from 'react';
import BaseModal from '../baseModal';
import './style.scss'; 
import { stacksExplorer, stacksExplorerParam } from '../../lib/constants';

const ConfirmModal = ({ show, setShow, txId, close, closePrevModal, userSettings }) => {
  const [explodeFire, setExplodeFire] = useState(false);

  if (typeof closePrevModal === 'function') {
    closePrevModal();
  }

  // Control the fire explosion effect
  useEffect(() => {
    if (show) {
      // Start the first explosion after 1 second
      const firstExplosion = setTimeout(() => setExplodeFire(true), 1000);

      // Repeat the explosion every 6 seconds
      const repeatExplosion = setInterval(() => setExplodeFire(true), 6000);

      return () => {
        clearTimeout(firstExplosion);
        clearInterval(repeatExplosion);
      };
    }
  }, [show]);

  // Handle closing the modal and stopping the animations
  const handleClose = () => {
    setExplodeFire(false); // Stop explosion when modal closes
    close();
  };

  return (
    <BaseModal show={show} setShow={setShow} handleClose={handleClose}>
      <p id="transaction-id" className="broadcast-modal-tx">
       Your transaction {`${String(txId).substring(0, 5)}...${String(txId).substring(txId.length - 5)}`} is in Progress
      </p>
      <h3>Transaction Broadcast</h3>
      <p>Takes at least 1 Stacks block to confirm.</p>
      <p>Approximately 5-10 seconds thanks to Nakamoto</p>
      <div id="view-tx-btn" className="broadcast-modal-tx__buttons">
        <button
          className="button"
          onClick={() => window.open(`${userSettings?.stacksExplorer || stacksExplorer}/txid/${txId}${stacksExplorerParam}`, "_blank")}
        >
          View in Explorer
        </button>
      </div>

      {/* Conditionally render the fire explosion */}
      {explodeFire && <div className="fire-explosion">🔥</div>}

    </BaseModal>
  );
};

export default ConfirmModal;
